module.exports = __webpack_public_path__ + "img/jr12.ab81275c.jpg";